import DropdownAbsolute from "@/components/global/menus/DropdownAbsolute";
import { useCart } from "@/context/cart";
// import { useClient } from "@/hooks/useClient";

import {
  checkRequiredSegments,
  // retainKeys
} from "@/utils/product";
import { handleAddItemsToCart } from "@/utils/product/addToCartFunc";
import { useState } from "react";

const BundleAddTotalsToCart = ({
  selectedProducts,
  setSelectedProducts,
  parentProduct,
  parentQty,
  t,
  parentInStock, 
  bundles,
  relatedProducts,
  setOpen = null,
  bundleSKUs: configurations,
  context
}) => {
  const [loading, setLoading] = useState(false);
  const { dispatch: dispatchCart } = useCart();
  // const {isClient} = useClient()
  const total =
    parentProduct?.prices_with_tax?.price * parentQty +
    selectedProducts?.reduce((agg, curr) => {
      return agg + curr?.prices_with_tax?.price * curr?.qty;
    }, 0);

  function calcSaving(product) {
    return (
      product?.prices_with_tax?.original_price - product?.prices_with_tax?.discounted_price
    );
  }

  const totalSavings =
    
    selectedProducts?.reduce((agg, curr) => {
      return agg + calcSaving(curr) * curr?.qty;
    }, 0);
    // const configurations = isClient && Object.values(retainKeys(parentProduct?.selectedConfigurations, ['attribute_id', 'option_id']))
  return (
    <div className="bg-[#F7F5F5] flex flex-col h-full justify-between  p-3 border rounded-md">
      <section>
        <h2 className="text-lg max-sm:text-sm font-bold">{t("Your Selected Items")}:</h2>
        <ul className="flex flex-col gap-2 mt-3 overflow-y-auto h-40 relative">
          {selectedProducts.map((product, i) => (
            <li key={i} className="text-[#4861A7] max-sm:text-sm flex items-center justify-between pe-4 gap-2 ">
              <p>{product?.name} </p>
              <DropdownAbsolute 
                  options={Array(20).fill(0).map((e, i) => ({label: i+1, value:i+1}))}
                  // defaultValue={1}
                  onChange={(e)=>{setSelectedProducts(prev => prev.map(p => p?.sku === product?.sku ? ({...p, qty:e?.target?.value}) : p))}}
                  selectedOption={product?.qty}
                />
              {/* <p>x {product?.qty}</p> */}
            </li>
          ))}
        </ul>
      </section>
      <section className="py-2 border-t">
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <p className="text-[#028C5B] font-bold max-sm:text-sm">
              {t("Total Savings")}: {totalSavings}
            </p>
            <p className="text-[#4861A7] font-bold max-sm:text-sm">
              {t("Items Total")}: {total}
            </p>
          </div>
          <button
            onClick={() =>
              {
                if(!checkRequiredSegments(bundles, selectedProducts)) {
                } else {
                  if (setOpen) {
                    setOpen(false)
                    setSelectedProducts([])
                  }
                  handleAddItemsToCart(configurations, setLoading, dispatchCart, configurations, context, relatedProducts, selectedProducts)
                }
                }
                
            }
            disabled={!parentInStock}
            className={`flex-1 p-3 text-sm font-bold  rounded-md ${!parentInStock ?"bg-gray-200 text-gray-600":"bg-primary text-white"} flex justify-center items-center gap-2`}
          >
            {loading && <div className="loader w-6 text-white" />}
            <p>{parentInStock? t("Add to cart") : t("Parent product is out of stock")}</p>
          </button>
        </div>
      </section>
    </div>
  );
};

export default BundleAddTotalsToCart;
